import { Autocomplete, Box, Button, Grid, MenuItem, TextField } from "@mui/material";
import { useState } from "react";
import { StyledClientFilterItem } from "views/tasks/Filters/styles";
import BillingEntities from "./billing-entities";
import ServiceDescription from "./service-description";
// import DeletedTasks from "./deleted-tasks";
// import TerminatedTasks from "./terminated-tasks";

function BillingEntitiesServiceDescription() {
  const [active, setActive] = useState("entities");

  const [filters, setFilters] = useState({
    completed: {
      financialYear: "",
      search: "",
      taskValue: 'all'
    },
    terminated: {
      financialYear: "",
      search: "",
      taskValue: 'all'
    },
  });

  return (
    <Grid container spacing={3} className="upcoming-card-container">
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Box  >
          <Box pl={2} pr={2} mb={0} pb={1} pt={1} display="flex" justifyContent="center" alignItems="center" sx={{ background: "rgba(24, 47, 83, 0.08)" }}>
            <Box display="flex" gap="15px" flexWrap="wrap" alignItems="center" className="upcoming-margin" justifyContent="center" >
              <StyledClientFilterItem
                variant="body1"
                color="rgba(0,0,0,0.7)"
                active={active === "entities" ? 1 : 0}
                onClick={() => setActive("entities")}
              >
                Billing Entities
              </StyledClientFilterItem>
              <StyledClientFilterItem
                variant="body1"
                color="rgba(0,0,0,0.7)"
                active={active === "service_description" ? 1 : 0}
                onClick={() => setActive("service_description")}
              >
                Service Fee Preferences
              </StyledClientFilterItem>
            </Box>
          </Box>
          {active === "entities" && <BillingEntities />}
          {active === "service_description" && <ServiceDescription />}
        </Box>
      </Grid>
    </Grid>
  );
}

export default BillingEntitiesServiceDescription;
